import { z } from "zod";

const count = z.number().int().nonnegative();
export const adminDashboardSchema = z.object({
  generatedAt: z.string().datetime(),
  totals: z.object({
    customers: count,
    residential: count,
    commercial: count,
    enterprise: count.default(0),
    complimentary: count,
    linkedNumbers: count,
    equipment: count,
  }),
  queues: z.object({
    setups: count,
    newInquiries: count,
    openMessages: count,
    portsNeedingInfo: count,
    ordersNeedingAttention: count,
  }),
  setups: z
    .array(
      z.object({
        id: z.string().uuid(),
        account_number: z.string(),
        name: z.string(),
        kind: z.enum(["residential", "commercial", "enterprise"]),
        status: z.enum(["draft", "pending_activation"]),
        billing_mode: z.enum(["standard", "complimentary"]),
        has_contact: z.boolean(),
        has_address: z.boolean(),
        has_number: z.boolean(),
        has_equipment: z.boolean(),
      }),
    )
    .max(8),
  activity: z
    .array(
      z.object({
        id: z.string().uuid(),
        account_id: z.string().uuid().nullable(),
        account_name: z.string().nullable(),
        action: z.string(),
        summary: z.string(),
        occurred_at: z.string().datetime(),
      }),
    )
    .max(10),
});

export type AdminDashboardData = z.infer<typeof adminDashboardSchema>;
